module.exports = __webpack_public_path__ + "static/media/Inter-Thin.a5fefa08.woff";